import { TagRepository } from "../domain/TagRepository";
import { Tag } from "../domain/Tag";
import { IHttpClient } from "../../../lib/http";
import { TagMultiUpdateResponse } from "../domain/TagMultiUpdateResponse";
import {
  GetTagsRequest,
  GetTagsResponse,
} from "../../../gen/witbooking/backoffice/tags/v1/tag_api_pb";
import { GrpcCall } from "../../../lib/grpc";
import { toTagDomainFromGrpc } from "./mappers/tagMapper";

export class ApiTagRepository implements TagRepository {
  constructor(
    private readonly httpClient: IHttpClient,
    private readonly getTags: GrpcCall<void, GetTagsRequest, GetTagsResponse>
  ) {}

  async getAll(): Promise<Tag[]> {
    const response = await this.getTags(new GetTagsRequest());
    return response.getTagsList().map(tag => toTagDomainFromGrpc(tag));
  }

  importTags(propertyTicker: string, file: File, token: string): Promise<TagMultiUpdateResponse> {
    const formData = new FormData();
    formData.append("file", file);

    return this.httpClient.post(`/v6/api/v1/${propertyTicker}/tags/multi-update`, formData, {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
